import React, { useEffect, useState } from 'react';
import { executeHttpRequest } from '../../epics/api';
import { TCategoryChoice, TClientData, TPageNotification, TUser } from '../../types';
import { getErrorMessages } from '../../utils';
import ClientDetails from './clientDetails';
import ClientAddresses from './clientAddresses';
import ClientAssignmentDetails from '../common/client/clientAssignmentDetails';
import ClientPayGrades from './clientPayGrades';
import ClientElectronicTimesheetApproval from './clientElectronicTimesheetApproval';

type TClientDetailsProps = {
    clientId: string;
    notification: TPageNotification;
    user: TUser;
}

export default function ClientDetailsContainer({
    clientId,
    notification,
    user,
}: TClientDetailsProps) {
    const [clientCategories, setClientCategories] = useState([]);
    const [clientData, setClientData] = useState<TClientData>(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchClientCategories = () => {
        executeHttpRequest('client-categories/')
            .then(res => {
                const categoryChoices = res.data.content.map(
                    (choice: TCategoryChoice) => ({
                        value: choice.id,
                        label: choice.category,
                    })
                );
                setClientCategories(categoryChoices);
            })
            .catch(err =>
                notification.error(
                    'Error',
                    `Could not fetch client categories: ${getErrorMessages(err)}`,
                )
            );
    };

    const fetchClientDetails = () => {
        executeHttpRequest(`clients/${clientId}/`)
            .then(response => {
                setIsLoading(false);
                setClientData(response.data.content);
            })
            .catch(err => {
                setIsLoading(false);
                notification.error(
                    'Error',
                    `Could not fetch client data: ${getErrorMessages(err)}`,
                );
            });
    };

    useEffect(() => {
        fetchClientCategories();
        fetchClientDetails();
    }, []);

    if (isLoading) {
        return (
            <div className="fetching-freelancer-info">
                <i className="icon icon-loading-1" />
            </div>
        );
    }

    if (!clientData) {
        return <></>;
    }

    return (
        <div className="freelancer-details-container">
            <div className="freelancer-details-header" style={{ marginTop: '100px' }}>
                <div className="freelancer-details-header__avatar">
                    <div className="freelancer-avatar">
                        <div className="freelancer-avatar__photo">
                            <img src={clientData.logo} alt=""/>
                        </div>
                        <div className="freelancer-avatar__name">{clientData.company_name}</div>
                    </div>
                </div>
            </div>
            <ClientDetails
                clientId={clientId}
                clientData={clientData}
                clientCategories={clientCategories}
                isSuperUser={user.isSuperUser}
                notification={notification}
                setClientData={setClientData}
            />
            <ClientPayGrades
                clientId={clientId}
                notification={notification}
            />
            <ClientAddresses
                clientId={clientId}
                notification={notification}
            />
            <ClientAssignmentDetails
                clientId={clientId}
                clientData={clientData}
                notification={notification}
                setClientData={setClientData}
                user={user}
            />
            <ClientElectronicTimesheetApproval
                clientId={clientId}
                clientData={clientData}
                notification={notification}
            />
        </div>
    );
}
